import type { ReactNode } from "react"

export default function AppBackground({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={`min-h-screen min-w-full bg-black text-white relative overflow-hidden ${className || ""}`}>
      <div className="pointer-events-none absolute inset-0">
        {/* Green radial gradient */}
        <div className="absolute inset-0 bg-[radial-gradient(60%_80%_at_70%_20%,rgba(180,255,214,0.20)_0%,rgba(180,255,214,0.06)_35%,transparent_70%)]" />
        
        {/* Blue radial gradient */}
        <div className="absolute inset-0 bg-[radial-gradient(70%_70%_at_15%_85%,rgba(93,124,255,0.28)_0%,rgba(93,124,255,0.10)_35%,transparent_72%)]" />
        
        {/* Dotted grid pattern */}
        <div className="absolute inset-0 opacity-40 [background-image:radial-gradient(rgba(255,255,255,0.08)_1px,transparent_1px)] [background-size:24px_24px] [background-position:0_0]" />
        
        {/* Grid lines */}
        <div className="absolute inset-0 opacity-25 [background-image:linear-gradient(rgba(255,255,255,0.06)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.06)_1px,transparent_1px)] [background-size:72px_72px]" />
        
        {/* Overlay gradient */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/20 to-black/55" />
      </div>
      <div className="relative z-10">{children}</div>
    </div>
  )
}
